export default __webpack_public_path__ + "static/media/control-180.e99c05cf.png";